import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../context/GlobalContext';
import LanguageDropdown from './LanguageDropdown';
import logo from '../assets/images/owlex-white.png';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const { navMenuItems } = useGlobalContext();

  const handleClick = (e, route) => {
    e.preventDefault();
    
    if (route === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (route.startsWith('#')) {
      const elementId = route.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Sol: Logo ve Quick Links */}
          <div className="footer-left">
            <div className="footer-brand">
              <img 
                src={logo} 
                alt="Owlex Logo" 
                className="footer-logo-img"
                onClick={handleLogoClick}
                style={{ cursor: 'pointer' }}
              />
              <p className="footer-description">
                {t('footer.description')}
              </p>
            </div>
            <div className="footer-menu">
              <h4 className="footer-menu-title">{t('footer.quickLinks')}</h4>
              <ul className="footer-links">
                {navMenuItems.map((item) => {
                  let translationKey = 'home';
                  if (item.label === 'Pricing Plans') translationKey = 'pricing';
                  if (item.label === 'Contact Us') translationKey = 'contact';
                  
                  return (
                    <li key={item.id}>
                      <a 
                        href={item.route} 
                        className="footer-link"
                        onClick={(e) => handleClick(e, item.route)}
                      >
                        {t(`nav.${translationKey}`)}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {/* Orta: İletişim */}
          <div className="footer-center">
            <div className="footer-contact">
              <h4 className="footer-menu-title">{t('footer.contact')}</h4>
              <ul className="footer-contact-list">
                <li>
                  <a href="tel:+902165045655" className="footer-contact-item">
                    +90 216 504 56 55
                  </a>
                </li>
                <li>
                  <a href="tel:+905464082722" className="footer-contact-item">
                    +90 546 408 27 22
                  </a>
                </li>
                <li>
                  <a href="mailto:info@experilabs.com" className="footer-contact-item">
                    info@experilabs.com
                  </a>
                </li>
                <li className="footer-contact-item">
                  Soğanlık Yeni Mah. Pamukkale Sk. No:11<br />
                  Kartal - İstanbul
                </li>
              </ul>
            </div>
          </div>

          {/* Sağ: Language Switch */}
          <div className="footer-right">
            <div className="footer-language">
              <h4 className="footer-menu-title">{t('footer.language')}</h4>
              <LanguageDropdown />
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

